class BotbHeader extends HTMLElement {
    constructor() {
        super();

        this.currentIndex = 0;
        const this_component = this;

        this.searchDrawer = document.querySelector('[drawer-type="search-drawer"]');
        this.searchPageLink = this.querySelector("[search_page_link]");
        this.searchDrawerButton = this.querySelector('[drawer-to-open="search-drawer"]');
        
        this.querySelectorAll('.botb-header-top-level-link.has-megamenu').forEach(function(item) {
            item.addEventListener('mouseover', function(evt) {
                item.classList.add('active');
                const index = evt.currentTarget.getAttribute('index');
                document.querySelectorAll('.botb-megamenu').forEach(function(megamenu) {
                    document.querySelectorAll('.botb-megamenu').forEach(function(megamenu_in_loop) {
                        if(megamenu_in_loop != megamenu) megamenu_in_loop.classList.remove('active');
                    })
                    document.getElementById('botb-megamenu-'+index).classList.add('active');
                });
                this_component.querySelectorAll('.botb-header-top-level-link.has-megamenu').forEach(function(item_in_loop) {
                    if(item_in_loop != item) item_in_loop.classList.remove('active');
                });
            })
        });

        this.querySelectorAll('.botb-header-top-level-link:not(.has-megamenu)').forEach(function(item) {
            item.addEventListener('mouseover', function(evt) {
                this_component.closeAllMegaMenus();
            })
        });

        this.addEventListener('mouseover', function(evt) {
            console.log('evt.target.classList:', evt.target.classList);
            if(evt.target.classList.contains('botb-header-inner')) {
                this_component.closeAllMegaMenus();
            }
        });

        document.querySelector('#botb-megamenu-container').addEventListener('mouseleave', function(evt) {
            this_component.closeAllMegaMenus();
        });

        if (this.searchDrawer) {
            this.searchPageLink.classList.add("d-none")
            this.searchDrawerButton.classList.remove("d-none")
        }
    }

    connectedCallback() {
        if (this.searchDrawer) {
            this.searchPageLink.classList.add("d-none")
            this.searchDrawerButton.classList.remove("d-none")
        }
    }

    closeAllMegaMenus() {
        document.querySelectorAll('.botb-megamenu').forEach(function(megamenu_in_loop) {
            megamenu_in_loop.classList.remove('active');
        })
        this.querySelectorAll('.botb-header-top-level-link.has-megamenu').forEach(function(item) {
            item.classList.remove('active');
        });
    }
}

customElements.define('botb-header', BotbHeader);

class BotbMobileNavToggle extends HTMLElement {
    constructor() {
        super();
        console.log('BotbMobileNavToggle constructor');
        this.addEventListener('click', this.toggleNav);
    }

    toggleNav() {
        const nav = document.querySelector('#botb-nav-drawer');
        if (nav) {
            this.classList.toggle('active');
            document.body.classList.toggle('nav-drawer-open');

            if(nav.classList.contains('active')) {
                nav.classList.add('is-transitioning');
                nav.classList.add('is-transitioning-backwards');
                setTimeout(function() {
                    nav.classList.remove('is-transitioning');
                    nav.classList.remove('active');
                    nav.classList.remove('is-transitioning-backwards');
                }, 350);
            } else {
                nav.classList.add('is-transitioning');
                setTimeout(function() {
                    nav.classList.remove('is-transitioning');
                    nav.classList.add('active');
                }, 350);
            }
        }

    }
}

customElements.define('botb-mobile-nav-toggle', BotbMobileNavToggle);

document.addEventListener('DOMContentLoaded', function() {

    let headerHeight = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function(el) {
        headerHeight += el.offsetHeight;
    });
    const navDrawer = document.querySelector('#botb-nav-drawer');
    if (navDrawer) {
        navDrawer.style.setProperty('--header-height', `${headerHeight}px`);
    }

    document.querySelectorAll('.botb-nav-drawer__details').forEach(function(el) {
        const fallback = el.closest('.botb-nav-drawer__second-level') ? 52 : 47;
        const button_height = el.querySelector('summary').offsetHeight || fallback;
        el.style.setProperty('--button-height', button_height+'px');
    });
});